import { thList } from "react-icons-kit/fa/thList";
import { server } from "react-icons-kit/fa/server";
import { globe } from "react-icons-kit/fa/globe";
import { languageService } from "../../Language/language.service";
import { versionInfo } from "../MainPage/VersionInfo";
import { fileText2 } from "react-icons-kit/icomoon/fileText2";

export const LIST_VIEW_SELECTION_TYPES = {
  LIST: "List",
  MAP: "Map",
  GIS: "GIS",
  REPORT: "Report",
};

export const LIST_VIEW_SELECTION = [
  {
    title: LIST_VIEW_SELECTION_TYPES.GIS,
    icon: globe,
    tooltip: {
      show: false,
      text: "GIS",
    },
  },
  {
    title: LIST_VIEW_SELECTION_TYPES.MAP,
    icon: server,
    tooltip: {
      show: false,
      text: "Track Chart",
    },
  },
  {
    title: LIST_VIEW_SELECTION_TYPES.LIST,
    icon: thList,
    tooltip: {
      show: false,
      text: "List",
    },
  },
  {
    title: LIST_VIEW_SELECTION_TYPES.REPORT,
    icon: fileText2,
    tooltip: {
      show: false,
      text: "Reports",
    },
  },
];

export const LIST_VIEW_SELECTION_GET = () => {
  if (versionInfo.isReVAMP()) return LIST_VIEW_SELECTION.filter((l) => l.title !== LIST_VIEW_SELECTION_TYPES.MAP);
  return LIST_VIEW_SELECTION;
};



// WEBPACK FOOTER //
// ./src/components/Maintenance/ViewSelection.js